import React, { useEffect, useRef, useState } from 'react';
import {
  CButton,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CTab,
  CTabContent,
  CTabList,
  CTabPanel,
  CTabs,
  CHeader, CContainer, CHeaderNav, CNavItem, CNavLink,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter
} from '@coreui/react'
import icone from '../../assets/images/info.png';
import icone2 from '../../assets/images/coeur.png';
import './appointment.css';
import { useLocation, useNavigate } from "react-router-dom";
import api from '../../service/caller';
import { ToastContainer, toast } from 'react-toastify';
import { usePermissions } from '../../contexts/PermissionContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Popover, OverlayTrigger, Button } from 'react-bootstrap';
import './appointment.css';


const AppointmentHistory = () => {
  const navigate = useNavigate();
  const handleViewHistory = () => {
    navigate("/hospitaladmin/patient_details"); // Redirigez à la page d'historique
  };
  const [UserData, setUserData] = useState([]);
  const [patients, setPatients] = useState([]);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [appointments, setAppointments] = useState([]);

  // GEt patients list
  const fetchPatients = async (page = 1) => {
    try {
      const response = await api.get(`/clinic/patients`);
      setPatients(response.data.patients);

    } catch (error) {
      console.error('Erreur lors de la récupération des patients:', error);
    } finally {
    }
  };

  useEffect(() => {
    const fetchLoggedUserData = async () => {
      try {
        const response = await api.get('api/usersprofile');

        setUserData(response.data);
      } catch (error) {
        toast.error("Failed to fetch data");
      }
    };
    fetchLoggedUserData();
  }, []);

  const doctorId = UserData._id;
  console.log('docid', doctorId);


  // liste des appointments 
  useEffect(() => {
    const fetchAppointments = async () => {
      try {
        const token = localStorage.getItem('access_token');
        if (!token) {
          throw new Error('Token not found');
        }

        const hospitalIds = Array.isArray(UserData.hospital_id) ? UserData.hospital_id : [UserData.hospital_id];

        // Créez une requête pour chaque hospitalId
        const promises = hospitalIds.map(hospitalId =>
          api.get(`/clinic/getAppointmentlist?hospitalId=${hospitalId._id || hospitalId}`, {
            headers: { Authorization: `Bearer ${token}` }
          })
        );

        const responses = await Promise.all(promises);

        // Combiner toutes les données des réponses
        const allAppointments = responses.flatMap(response => response.data);

        // Filtrer les rendez-vous dont paymentstatus est true

        const appointmentsWithPaymentStatus = allAppointments.filter(appointment =>
          appointment.paymentStatus === true &&
          appointment.doctorId === UserData._id &&
          ['Cancelled', 'Completed'].includes(appointment.status)
        );

        // Ajouter la vérification des signes vitaux pour chaque rendez-vous
        const appointmentsWithSignVitalStatus = await Promise.all(
          appointmentsWithPaymentStatus.map(async (appointment) => {
            const signVitalExists = await fetchSignVitalStatus(appointment._id);
            return {
              ...appointment,
              signVitalExists,  // Ajout de la propriété `signVitalExists` à l'objet appointment
            };
          })
        );

        setAppointments(appointmentsWithSignVitalStatus);  // Mettre à jour l'état avec les rendez-vous filtrés

      } catch (error) {
        console.error('Error fetching appointments:', error);
        toast.error("Failed to fetch appointments");
      }
    };

    if (UserData && UserData.hospital_id) {
      fetchAppointments();
    }
  }, [UserData]);


  // Fonction pour vérifier si des signes vitaux existent pour un rendez-vous
  const fetchSignVitalStatus = async (appointmentId) => {
    try {
      const response = await api.get(`/clinic/signvitalforappointment/${appointmentId}`);
      return response.data.signVitaldata;
    } catch (error) {
      console.error('Erreur lors de la vérification des signes vitaux:', error);
      return false; // En cas d'erreur, on suppose qu'il n'y a pas de signes vitaux
    }
  };

  // listes des departments
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await api.get(`/api/departments`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          }
        });

        // Mettre à jour les départements dans l'état
        setDepartments(response.data.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des départements:', error);
      }
    };
    fetchDepartments(); // Appel de la fonction pour récupérer les départements
  }, []);

  const popoverRefs = useRef([]);

  useEffect(() => {
    popoverRefs.current.forEach((popoverEl) => {
      if (popoverEl) {
        new window.bootstrap.Popover(popoverEl, {
          html: true,
        });
      }
    });
  }, []);

  const handleGoBack = () => {
    navigate(-1); // Cela permet de revenir à la page précédente dans l'historique
  };

  return (
    <div className="py-4" style={{ fontFamily: 'Arial, sans-serif' }}>
      <h2 className="fw-bold" style={{ color: '#0056B3', fontSize: '42px', marginBottom: '40px' }}>
        Your appointments
      </h2>

      <div className="card p-4">
        <div className="card-body">
          {/* Navigation Bar */}
          <nav className="navbar navbar-expand-lg navbar-light bg-white mb-4">
            <div className="d-flex align-items-center gap-3 w-100">
              <button className="btn btn-outline-primary d-flex align-items-center" onClick={handleGoBack}>
                <i className="bi bi-arrow-left me-2"></i>
                Retour
              </button>

              <div className="input-group">
                <span className="input-group-text bg-white border-end-0">
                  <i className="bi bi-search"></i>
                </span>
                <input type="text" className="form-control border-start-0" placeholder="Search..." />
              </div>

              <select className="form-select" style={{ maxWidth: '150px' }}>
                <option value="">Months</option>
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </select>

              <select className="form-select" style={{ maxWidth: '150px' }}>
                <option value="">Past years</option>
                <option value="2024">2024</option>
                <option value="2023">2023</option>
                <option value="2022">2022</option>
                <option value="2021">2021</option>
              </select>

              <div className="input-group" style={{ maxWidth: '200px' }}>
                <input type="date" className="form-control" placeholder="Search by date" />

              </div>
            </div>
          </nav>

          <CTable className="mt-5 table ctable-no-border " align="middle" responsive>
            <CTableHead className="thead-light">
              <CTableRow className='tablehead text-primary'>
                <CTableHeaderCell className='text-primary' scope="col">Time</CTableHeaderCell>
                <CTableHeaderCell className='text-primary' scope="col">Date</CTableHeaderCell>
                <CTableHeaderCell className='text-primary' scope="col">Patient</CTableHeaderCell>
                <CTableHeaderCell className='text-primary' scope="col">Phone number</CTableHeaderCell>
                <CTableHeaderCell className='text-primary' scope="col">Actions</CTableHeaderCell>
                <CTableHeaderCell className='text-primary' scope="col">Status</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {appointments.map((appointment, index) => (
                <CTableRow className="ctable-row" key={index}>
                  <CTableDataCell className='text-primary'>
                    <p style={{ lineHeight: '5px', marginTop: '15px' }}>{appointment.appointmentTime}</p>
                    <p style={{ lineHeight: '5px', width: '40px', backgroundColor: 'blue', height: '1px' }}></p>
                    <p style={{ lineHeight: '5px' }}>{appointment.appointmentEndTime}</p>
                  </CTableDataCell>
                  <CTableDataCell>{appointment.appointmentDate?.split("T")[0]}</CTableDataCell>
                  <CTableDataCell>{appointment.patientId?.firstname || 'Unknown'} {appointment.patientId?.lastname || 'Unknown'}</CTableDataCell>
                  <CTableDataCell> {appointment.patientId?.phone}</CTableDataCell>
                  <CTableDataCell><img
                    className="btn me-2 cursor-pointer"
                    data-bs-toggle="popover"
                    data-bs-title="Vital Signs"
                    data-bs-content={`Body Temperature: <strong style="color: red;">fffffffffffffffffff</strong><br /><hr>Blood Pressure: <strong>ffffffffffffffff</strong><br />Note: <strong>}</strong>`}
                    data-bs-placement="bottom"
                    data-bs-custom-class="custom-popover"
                    src={icone2}
                    ref={(el) => (popoverRefs.current[0] = el)} // Nous stockons l'élément dans popoverRefs
                    alt="Icon for Popover"
                  />
                    <img
                      className="me-2 btn cursor-pointer"
                      src={icone}
                      alt="Heart Icon"
                    /></CTableDataCell>
                  <CTableDataCell className='Patientlist'>
                    <span className={appointment.status === 'Completed' ? 'coloredsucess' : 'coloredechec'}>
                      {appointment.status}
                    </span>
                  </CTableDataCell>
                  <CTableDataCell></CTableDataCell>
                </CTableRow>
              ))}
            </CTableBody>
          </CTable>
          <div className="text-end">Showing 1-09 of 78</div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentHistory;